import { html } from 'lit-element';

import { LightLitElement } from '@elab/components';

/**
 * Component uses for configure layout of wishlist component
 *
 * @attr { String } [wrap-options] - wrapper for the options (variant, quantity, price, add-to-cart) in order to get a big image container
 *
 * HTML Structure Example
 *
 * <e2-wishlist-row-layout
 *  wrap-options
 * ></e2-wishlist-row-layout>
 * */

export class WishlistRowLayout extends LightLitElement {
    static get properties() {
        return {
            wrapOptions: { type: Boolean, attribute: 'wrap-options' },
        };
    }

    render() {
        return html`
            <div class="wishlist__column-container">
                <div class="wishlist__column wishlist__column--image">
                    <v-slot name="product-image"></v-slot>
                </div>

                ${this.wrapOptions
                    ? html`
                          <div class="wishlist__wrapper">
                              ${this.optionsTemplate}
                          </div>
                      `
                    : this.optionsTemplate}

                <v-slot name="product-tag"></v-slot>
                <v-slot name="product-remove"></v-slot>
                <v-slot name="product-promotions"></v-slot>
                <div class="d-none">
                    <v-slot name="product-quantity"></v-slot>
                    <v-slot name="quantity-counter"></v-slot>
                    <v-slot name="product-price"></v-slot>
                    <v-slot name="product-move-item-to"></v-slot>
                    <v-slot name="product-variant"></v-slot>
                </div>
            </div>
        `;
    }

    get optionsTemplate() {
        return html`
            <div class="wishlist__columns">
                <div class="wishlist__column wishlist__column--info">
                    <v-slot name="product-info"></v-slot>
                    <v-slot name="egiftcard-info"></v-slot>
                </div>

                <div class="wishlist__column wishlist__column--variant-type-text">
                    <v-slot name="product-variant-type-text"></v-slot>
                </div>
            </div>
            <div class="wishlist__columns">
                <div class="wishlist__column wishlist__column--price">
                    <v-slot name="product-price-with-discount"></v-slot>
                </div>
                <div class="wishlist__column wishlist__column--add-to-cart">
                    <v-slot name="product-add-to-cart"></v-slot>
                </div>
            </div>
        `;
    }
}

export default () => customElements.define('e2-wishlist-row-layout', WishlistRowLayout);
